goog.provide('el8.appchart.dialog.ordermed.extractMedData');

goog.require('el8.util.datecompare');
goog.require('el8.service.tz');
goog.require('el8.ptdata.model.med.medOrder');
goog.require('el8.data.medications');
goog.require('el8.data.base');
goog.require('el8.data.referencedPracticians');
goog.require('el8.appchart.dialog.ordermed.util');

el8.appchart.dialog.ordermed.extractMedData = function(main, model, isSignedOff) {

    var _getPharmacyInstructions = function() {
        var pharmacyInstructions = main._optFields['pharmacyInstr'] ?
            main._optFields['pharmacyInstr'].getVal() : '';
        var startDate = main._requiredFields['startDate'].noInput() ? null :
            main._requiredFields['startDate'].getVal();

        /* If have a future Fill Date, then add to the Notes field
        RM-22827 - Since we have a dedicated field for this now, remove the
        'fill date' information added to pharmacy instructions / notes
        because users were finding the information in the notes confusing
        when there were refills causing multiple appended 'fill date' information.
         */
        return el8.util.string.replaceNewlines(pharmacyInstructions);
    };

    if (!model) {
        model = el8.ptdata.model.med.medOrder({
            model_class: 'MedOrder',
            documentDate: el8.service.tz.now(),
            startDate: el8.service.tz.today()
        });
    }

    var medicationName = main._requiredFields['medication'].getVal();

    // Make absolute sure we are matching up what's on the display
    var medication = null;
    var selectedMedication = main._selected['medication'];
    if (selectedMedication && selectedMedication.getCleanName() === medicationName) {
        medication = selectedMedication;
    } else {
        medication = el8.data.medications.getByDisplayName(medicationName);
    }

    if (!medication) {
        // Get free text medication name and strength from what was entered in dialogNewMed
        // Make absolute sure we are matching up what's displaying
        if (medicationName ===
                el8.appchart.dialog.ordermed.util.displayMed(
                    main._selected['newMedicationName'],
                    main._selected['newMedicationStrength'])) {
            main._data['manual_medication_name'] = main._selected['newMedicationName'];
            main._data['manual_medication_strength'] = main._selected['newMedicationStrength'];
            model.setMedicationId(null);
        }
    }
    // Pass this along, just in case there are user updates (server decides whether they
    // are allowed) For "medicationIsPrescription", logic is according to
    // medsListSelectField (true if either 'rx' or 'temp')
    var isPrescription = main._optFields['medsListSelect'] ?
        (main._optFields['medsListSelect'].filter(':checked').val() !== 'otc') :
        (!main._optDivs['medType'] || (main._optDivs['medType'] !== 'otc'));
    main._data['medication_is_prescription'] = isPrescription;

    main._data['medication_is_controlled'] = medication ? medication.isControlled() :
        (main._optDivs['medType'] && (main._optDivs['medType'].text() === 'controlled'));

    // Get treatment start date if relevant
    if (main._optFields['txStartDate'] &&
            (!main._optDivs['txStartDate'] || main._optDivs['txStartDate'].is(':visible'))) {
        // Set start date
        main._data['tx_start_date'] = main._optFields['txStartDate'].noInput() ? null :
            main._optFields['txStartDate'].getVal();

        // Now get old medication info, only if have tx start date
        if (main._optFields['oldMed'] &&
                (!main._optDivs['oldMedInfo'] ||
                 main._optDivs['oldMedInfo'].is(':visible'))) {
            var medName = main._optFields['oldMed'].getVal();
            var oldMedication = null;
            if (main._selected['oldMedication'] &&
                    main._selected['oldMedication'].getCleanName() === medName) {
                oldMedication = main._selected['oldMedication'];
            } else {
                oldMedication = el8.data.medications.getByDisplayName(medName);
            }
            if (!oldMedication) {
                var oldMedicationName = main._selected['oldMedicationName'];
                var oldMedicationStrength = main._selected['oldMedicationStrength'];
                if (medName ===
                        el8.appchart.dialog.ordermed.util.displayMed(oldMedicationName, oldMedicationStrength)) {
                    main._data['old_medication_name'] = oldMedicationName;
                    main._data['old_medication_strength'] = oldMedicationStrength;
                }
            } else {
                main._data['old_medication_id'] = oldMedication.getId();
            }
            // Take isPrescription and isControlled from current order
            main._data['old_medication_is_prescription'] =
                main._data['medication_is_prescription'];
            main._data['old_medication_is_controlled'] =
                main._data['medication_is_controlled'];
            main._data['old_directions'] = main._optFields['oldDirections'] ?
                main._optFields['oldDirections'].getVal() : null;
        }
    }

    // Prescribing physician information
    var prescribingPhysicianId = null;
    var isSelfPrescribed = false;
    if (main._isRx) {
        // Rx - set prescribing physician to currently logged in physician
        var currUser = el8.data.currUser;
        var delegatingPhysicians = currUser.getRxDelegatingPhysicianIdsInWorkspace();

        if (delegatingPhysicians.length) {
            if (delegatingPhysicians.length === 1) {
                prescribingPhysicianId = delegatingPhysicians[0];
            } else if (model.getPrescribingPhysicianId()) {
                // set by selectPrescribingPhysician dialog, which was triggered by ordermed/validate.js
                prescribingPhysicianId = model.getPrescribingPhysicianId();
            }
        } else if (currUser.isPhysician()) {
            prescribingPhysicianId = currUser.getStaffId();
        }
    } else {
        var prescriberInfo = el8.appchart.dialog.ordermed.util.extractPrescriberInfo(
            main._physicianSearchField, main._optFields['prescriber']);

        prescribingPhysicianId = prescriberInfo['prescribingPhysicianId'];
        isSelfPrescribed = prescriberInfo['isSelfPrescribed'];
        if (prescriberInfo['prescriberName']) {
            main._data['manual_prescribing_physician_name'] = prescriberInfo['prescriberName'];
        }
    }

    var directions = main._requiredFields['directions'].getVal();

    var indication = main._optFields['indication'] ?
        main._optFields['indication'].getVal() : '';

    var quantity = main._optFields['quantity'] ?
        main._optFields['quantity'].getVal() : '';

    var quantityUnits = main._optFields['quantityUnits'] ?
        main._optFields['quantityUnits'].getVal() : '';

    var daysSupply = null;

    if ((quantityUnits.toLowerCase() === 'days' ||
            quantityUnits.toLowerCase() === 'day')
            && main._selected['qtyPerDay'] && quantity) {
        daysSupply = quantity;
        quantity = (main._selected['qtyPerDay'] * daysSupply).toString();
        quantityUnits = '';
    }

    var authRefills = main._optFields['authRefills'] ?
        main._optFields['authRefills'].getVal() : '';
    var numSamples = main._optFields['numSamples'] ?
        main._optFields['numSamples'].getVal() : '';
    var notes = main._optFields['notes'] ? main._optFields['notes'].getVal() : '';

    // Template?
    var templateId = main._templateId ? main._templateId : null;

    // Get checkbox info
    var allowSubstitutions = main._optFields['substitutionsCheckbox'] ?
        !main._optFields['substitutionsCheckbox'].is(':checked') : null;
    var orderType = main._optFields['orderTypeSelect'] ?
        main._optFields['orderTypeSelect'].val() : '';

    // If not an Rx, order type can be "discontinue", which gets registered
    // as a new medication, and then a discontinued med
    if (!main._isRx && orderType === 'DcMed') {
        orderType = 'New';
    }

    var startDate = main._requiredFields['startDate'].noInput() ? null :
        main._requiredFields['startDate'].getVal();
    var pharmacyInstructions = _getPharmacyInstructions();

    var isThreadPermanent = main._optFields['addToPermanentCheckbox'] ?
        main._optFields['addToPermanentCheckbox'].is(':checked') : true; // default to true
    main._data['is_thread_permanent'] = isThreadPermanent;

    main._data['packaged_med_id'] = main._decisionSupport.getFormularyPackagedMedId();
    main._data['eligibility_id'] = main._decisionSupport.getFormularyEligibilityId();

    // If this is NOT an Rx, then we must add a documenting personnel
    // This is what signifies that we don't have an Rx
    if (!main._isRx) {
        model.setDocumentingPersonnelId(el8.data.currUser.getStaffId());
    }

    model.setThreadId(main._selected['relatedThreadId']);

    var icd10Ids;
    if (main._optFields.dxCodes && main._icd10Listeditor) {
      icd10Ids = main._icd10Listeditor.getIcdIdLists().icd10Ids;
    }

    if (isSignedOff) {
        model.setSignDate(el8.service.tz.now());
        model.setSignUserId(el8.data.currUser.getId());
    } else {
        model.setSignDate(null);
        model.setSignUserId(null);
    }
    if (medication) {
        model.setMedicationId(medication.getId());
    }
    if (icd10Ids) {
      model.setIcd10Ids(icd10Ids);
    }
    model.setPrescribingPhysicianId(prescribingPhysicianId);
    model.setType(orderType);
    model.setPrintType(main._printFormType);
    model.setPrescription(isPrescription);
    model.setSelfPrescribed(isSelfPrescribed);
    model.setStartDate(startDate || el8.service.tz.today());
    model.setDirections(directions);
    model.setIndication(indication);
    model.setQuantity(quantity);
    model.setQuantityUnits(quantityUnits);
    model.setAuthRefills(authRefills);
    model.setNumSamples(numSamples);
    model.setPharmacyInstructions(pharmacyInstructions);
    model.setAllowSubstitutions(allowSubstitutions);
    model.setNotes(notes);

    model.setTemplateId(templateId);

    /** Set metadata **/
    model.setMetadata(main._data);

    model.setCreateDate(el8.service.tz.toTzDateTime(main._createDate) || null);

    return model;

};
